import PropTypes from 'prop-types';
import React from 'react';

// Footer for server-paged list pages: "Rows per page" select, the
// "x–y of N items" range and First / Prev / Page X of Y / Next / Last.
// Styled by the shared list-page classes (to-footer, to-pager*), so the page
// must load the list-page stylesheet (pages/TenderOpening/components/TenderOpening.css).
const ListPager = ({
  currentPage,
  rowsPerPage,
  totalRows,
  isLoading = false,
  rowsPerPageOptions = [10, 25, 50, 100],
  onPageChange,
  onRowsPerPageChange,
}) => {
  const totalPages = Math.max(1, Math.ceil(totalRows / rowsPerPage));
  const startEntry = totalRows === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
  const endEntry = Math.min(currentPage * rowsPerPage, totalRows);
  const atFirst = currentPage <= 1 || isLoading;
  const atLast = currentPage >= totalPages || isLoading;

  return (
    <div className='to-footer'>
      <div className='d-flex flex-wrap align-items-center gap-2'>
        <span>Rows per page</span>
        <select
          className='form-select form-select-sm'
          style={{ width: 'auto' }}
          value={rowsPerPage}
          onChange={e => onRowsPerPageChange(parseInt(e.target.value, 10))}
          aria-label='Rows per page'
        >
          {rowsPerPageOptions.map(option => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <span className='to-footer-range'>
          {startEntry}–{endEntry} of <strong>{totalRows}</strong> items
        </span>
      </div>

      <nav className='to-pager' aria-label='Pagination'>
        <button
          type='button'
          className='to-pager-btn'
          disabled={atFirst}
          onClick={() => onPageChange(1)}
          aria-label='First page'
          title='First page'
        >
          <i className='ri-skip-back-line' aria-hidden='true' />
        </button>
        <button
          type='button'
          className='to-pager-btn'
          disabled={atFirst}
          onClick={() => onPageChange(currentPage - 1)}
          aria-label='Previous page'
          title='Previous page'
        >
          <i className='ri-arrow-left-s-line' aria-hidden='true' />
        </button>
        <span className='to-pager-current' aria-live='polite' aria-atomic='true'>
          Page {currentPage} of {totalPages}
        </span>
        <button
          type='button'
          className='to-pager-btn'
          disabled={atLast}
          onClick={() => onPageChange(currentPage + 1)}
          aria-label='Next page'
          title='Next page'
        >
          <i className='ri-arrow-right-s-line' aria-hidden='true' />
        </button>
        <button
          type='button'
          className='to-pager-btn'
          disabled={atLast}
          onClick={() => onPageChange(totalPages)}
          aria-label='Last page'
          title='Last page'
        >
          <i className='ri-skip-forward-line' aria-hidden='true' />
        </button>
      </nav>
    </div>
  );
};

ListPager.propTypes = {
  currentPage: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  totalRows: PropTypes.number.isRequired,
  isLoading: PropTypes.bool,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
  onPageChange: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
};

export default ListPager;
